/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import openToast from "utils/openToast";

class FetchSuccess {
  constructor(res, options) {
    const settings = {
      message: "",
      shapeData: null,
      decrypt: false,
    };

    if (options) {
      if (typeof options === "string") {
        settings.message = options;
      }

      if (typeof options === "object") {
        Object.assign(settings, options);
      }
    }

    const { message, shapeData, decrypt } = settings;
    if (message && message.length > 0) {
      openToast(message, "success");
    }

    if (res.status === 204) {
      this.data = null;
      this.status = "SUCCESS";
      this.ok = true;
      this.statusCode = res.status;
      this.error = null;
      this.response = res;
      return this;
    } else {
      return Promise.resolve(res.clone().json()).then((data) => {
        let _data = data;
        // The decryption must be on the top.
        if (decrypt) {
          _data = this.#decryption(_data);
        }
        // to skip pagination payload.
        if (res.url.includes("offset") === false) {
          if (data.hasOwnProperty("data")) _data = data.data;
        }

        if (shapeData) {
          _data = shapeData(_data);
        }

        this.data = _data;
        this.status = "SUCCESS";
        this.ok = true;
        this.statusCode = res.status;
        this.error = null;
        this.response = res;
        return this;
      });
    }
  }

  #decryption = (data) => {
    // TBD
    return data;
  };
}

export default FetchSuccess;
